<template>
    <v-dialog v-model="dialog" max-width="550px" persistent>
        <v-card>
            <v-card-title class="bg-primary text-white d-flex align-center justify-space-between py-3">
                <span class="text-h6"><v-icon left class="mr-2">mdi-lifebuoy</v-icon>Contatta Assistenza</span>
                <v-btn icon="mdi-close" variant="text" color="white" @click="chiudi"></v-btn>
            </v-card-title>

            <v-card-text class="mt-4">
                <v-form ref="form" v-model="valid">
                    <v-select v-model="ticket.tipo" :items="['Errore/Bug', 'Feedback', 'Suggerimento', 'Altro']"
                        label="Tipo di Segnalazione" variant="outlined" density="comfortable"
                        :rules="[v => !!v || 'Campo obbligatorio']"></v-select>

                    <v-text-field v-model="ticket.oggetto" label="Oggetto" variant="outlined" density="comfortable"
                        :rules="[v => !!v || 'Campo obbligatorio']"></v-text-field>

                    <v-textarea v-model="ticket.descrizione" label="Descrizione dettagliata del problema o richiesta"
                        variant="outlined" rows="4" :rules="[v => !!v || 'Campo obbligatorio']"></v-textarea>

                    <v-file-input v-model="fileAllegato" label="Allega Screenshot o File (Opzionale)" variant="outlined"
                        density="comfortable" prepend-icon="mdi-paperclip" show-size
                        accept="image/*,application/pdf,.csv,.xlsx"></v-file-input>
                </v-form>
            </v-card-text>

            <v-card-actions class="justify-end pb-4 pr-4">
                <v-btn color="grey-darken-1" variant="text" @click="chiudi" :disabled="loading">Annulla</v-btn>
                <v-btn color="secondary" variant="flat" @click="invia" :loading="loading" :disabled="!valid">
                    Invia Segnalazione
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { inviaTicketSupporto } from "@/api/comunicazioni/api.assistenza.js";

export default {
    name: "DialogSupporto",
    data() {
        return {
            dialog: false,
            valid: false,
            loading: false,
            fileAllegato: null,
            ticket: {
                tipo: "Errore/Bug",
                oggetto: "",
                descrizione: ""
            }
        };
    },
    methods: {
        apri() {
            this.ticket.tipo = "Errore/Bug";
            this.ticket.oggetto = "";
            this.ticket.descrizione = "";
            this.fileAllegato = null;
            this.dialog = true;
            if (this.$refs.form) this.$refs.form.resetValidation();
        },
        chiudi() {
            this.dialog = false;
        },
        async invia() {
            if (!this.valid) return;
            this.loading = true;

            try {
                const formData = new FormData();
                formData.append("tipo", this.ticket.tipo);
                formData.append("oggetto", this.ticket.oggetto);
                formData.append("descrizione", this.ticket.descrizione);

                if (this.fileAllegato) {
                    // Vuetify 3 v-file-input ritorna un oggetto File o un array di File
                    const file = Array.isArray(this.fileAllegato) ? this.fileAllegato[0] : this.fileAllegato;
                    if (file) formData.append("allegato", file);
                }

                const response = await inviaTicketSupporto(formData);
                this.$store.commit("app/showMessage", { testo: response.data.messaggio, tipo: "success" });
                this.chiudi();
            } catch (error) {
                console.error(error);
                // L'interceptor gestisce già i messaggi standard, ma in caso di fail locale resettiamo il loading
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>